import { useParams } from 'react-router-dom'
import { useGetTeamByIdQuery } from '../../api/client'
import ErrorMessageContainer from '../../components/errors/ErrorMessageContainer'
import EnhancedTeamDetailsForm from '../../components/team/EnhancedTeamDetailsForm'
import Spinner from '../../components/Spinner'

type ParamTypes = {
    teamId: string
}

function TeamEditPage() {
    // Which user are we editing?
    const { teamId: teamIdString } = useParams<ParamTypes>()
    const teamId = Number(teamIdString)

    // Fetch the user
    const {
        data: teamData,
        loading: teamLoading,
        error: teamError
    } = useGetTeamByIdQuery({
        variables: { teamId: teamId },
        fetchPolicy: 'network-only'
    })

    // Handle errors
    if (teamError) {
        return <ErrorMessageContainer message={teamError.message} />
    }

    if (teamLoading) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <Spinner size={8} />
            </div>
        )
    } else if (!teamLoading && teamData?.getTeamById) {
        // Display the enhanced form
        return (
            <div className="min-h-screen bg-gray-50 py-8">
                <EnhancedTeamDetailsForm team={teamData?.getTeamById} />
            </div>
        )
    }
    return (
        <div className="flex items-center justify-center min-h-screen">
            <div className="text-center">
                <h2 className="text-lg font-medium text-gray-900">Team not found</h2>
                <p className="text-gray-500">The team with ID {teamId} could not be loaded.</p>
            </div>
        </div>
    )
}

export default TeamEditPage
